//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GoogleMaps from '../../components/general/GoogleMaps'

export default {
    metaInfo: {
        meta: [
            {charset: 'utf-8'},
            {
                name: 'viewport',
                content:
                    'width=device-width, initial-scale=1, user-scalable=no',
            },
        ],
    },
    data() {
        return {
            orderNo: '',
            name: '',
            specialComments: '',
            selectedItemIndex: 0,
            seamless: false,
            whatsappNumber: '60539696',
            selectedItem: {},
            paymentMethods: [
                {label: 'Yappy', value: 'Yappy'},
                {label: 'Efectivo', value: 'Efectivo'},
            ],
            pickupMethods: [
                {label: 'Delivery', value: 'Delivery'},
                {label: 'Retirar en local', value: 'Retirar en local'},
            ],
            selectedPickupMethod: '',
            selectedPaymentMethod: null,
            address: '',
            total: 0,
            location: [],
            markers: [],
            center: {},
            optionsDialog: false,
            stylesDialog: false,
            successDialog: false,
            cartDialog: false,
            deliveryCostDialog: false,
            cart: [],
            menu: [
                {
                    title: 'Hotdog Hawaiiano',
                    desc:
                        'Ketchup, mayonesa, queso blanco rayado, papitas trituradas y jalea de piña.',
                    type: 'main',
                    pic: 'hotdog_hawaiiano.jpg',
                    price: 2.75,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                        {
                            title: 'Chorizo',
                            price: 0.75,
                        },
                    ],
                },
                {
                    title: 'Hotdog Panameño',
                    desc:
                        'Ketchup, mayonesa, pico de gallo y queso amarillo fundido.',
                    type: 'main',
                    pic: 'hotdog_panameno.jpeg',
                    price: 2.75,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                        {
                            title: 'Chorizo',
                            price: 0.75,
                        },
                    ],
                },
                {
                    title: 'Chillidog',
                    desc:
                        'Ketchup, mayonesa, carne molida, y queso amarillo fundido.',
                    type: 'main',
                    pic: 'chillidog.jpeg',
                    price: 3.5,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                        {
                            title: 'Chorizo',
                            price: 0.5,
                        },
                    ],
                },
                {
                    title: 'Chorichilli',
                    desc: '',
                    type: 'main',
                    pic: 'chillidog.jpeg',
                    price: 3.75,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Hamburguesa de carne',
                    desc:
                        'Ketchup, mayonesa, lechuga, tomate, queso amarillo fundido, carne de res 8oz.',
                    type: 'main',
                    pic: 'hamburguesa_carne.jpeg',
                    price: 4.5,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                        {
                            title: 'Con tocino',
                            price: 1,
                        },
                    ],
                },
                {
                    title: 'Hamburguesa de pollo',
                    desc:
                        'Mayonesa, lechuga, tomate, tender de pechuga de pollo, queso blanco, o amarillo.',
                    type: 'main',
                    pic: 'hamburguesa_pollo.jpeg',
                    styles: [],
                    sides: [],
                    price: 4.5,
                    options: [
                        {
                            title: 'Regular con queso blanco',
                            price: 0,
                        },
                        {
                            title: 'Regular con queso amarillo',
                            price: 0,
                        },
                        {
                            title: 'Con tocino y queso blanco',
                            price: 1,
                        },
                        {
                            title: 'Con tocino y queso amarillo',
                            price: 1,
                        },
                    ],
                },
                {
                    title: 'Hamburguesa con tocino',
                    desc: '',
                    type: 'main',
                    pic: '',
                    price: 5.5,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Hamburguesa Bulldog',
                    desc:
                        'Carne de res 8oz, tender de pollo, tocino, lechuga, tomate, queso amarillo fundido, ketchup y mayonesa.',
                    type: 'main',
                    pic: 'hamburguesa_bulldog.jpeg',
                    styles: [],
                    sides: [],
                    price: 7,
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Hamburguesa Doble Carne',
                    desc: '',
                    type: 'main',
                    pic: 'hamburguesa doble carne.jpeg',
                    styles: [],
                    sides: [],
                    price: 8,
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Burritos',
                    desc:
                        'Elige entre burrito de carne, burrito de pollo o burrito mixto.',
                    type: 'main',
                    pic: 'burrito_carne.jpeg',
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Carne',
                            price: 4.5,
                        },
                        {
                            title: 'Pollo',
                            price: 4.5,
                        },
                        {
                            title: 'Mixto',
                            price: 5.5,
                        },
                        // {
                        //     title: 'Vegetariano',
                        //     price: 4.5,
                        // },
                    ],
                },
                {
                    title: 'Salchipapas Sencillas',
                    desc:
                        'Papas, salchichas, ketchup, mayonesa y queso amarillo.',
                    type: 'main',
                    pic: 'salchipapas.jpeg',
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Personal',
                            price: 4,
                        },
                        {
                            title: 'Grande',
                            price: 6,
                        },
                    ],
                },
                {
                    title: 'Salchipapas Revoltosa',
                    desc:
                        'Papas fritas, salchichas, ketchup, mayonesa, queso amarillo, carne molida o pollo y pico de gallo.',
                    type: 'main',
                    pic: 'Revoltosa carne,pollo o mixta.jpeg',
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Carne - Personal',
                            price: 5,
                        },
                        {
                            title: 'Pollo - Personal',
                            price: 5,
                        },
                        {
                            title: 'Mixta - Personal',
                            price: 5.5,
                        },
                        {
                            title: 'Carne - Grande',
                            price: 7.5,
                        },
                        {
                            title: 'Pollo - Grande',
                            price: 7.5,
                        },
                        {
                            title: 'Mixta - Grande',
                            price: 8,
                        },
                    ],
                },
                {
                    title: 'Choripapas Sencillas',
                    desc: '',
                    type: 'main',
                    pic: 'Choripapas.jpeg',
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Personal',
                            price: 4.5,
                        },
                        {
                            title: 'Grande',
                            price: 6.5,
                        },
                    ],
                },
                {
                    title: 'ChoriRevoltosa',
                    desc: '',
                    type: 'main',
                    pic: '',
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Personal Pollo',
                            price: 5.5,
                        },
                        {
                            title: 'Personal Carne',
                            price: 5.5,
                        },
                        {
                            title: 'Grande Pollo',
                            price: 8,
                        },
                        {
                            title: 'Grande Carne',
                            price: 8,
                        },
                    ],
                },
                {
                    title: 'MegaRevoltosa',
                    desc: '',
                    type: 'main',
                    pic: 'Mega Revoltosa.jpeg',
                    price: 8.5,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Combo Hotdog Hawaiano',
                    desc: '',
                    type: 'main',
                    pic: 'Combo hotdog choridog.jpeg',
                    price: 7,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Coca Cola',
                            price: 0,
                        },
                        {
                            title: 'GingerAle',
                            price: 0,
                        },
                        {
                            title: 'Dr. Pepper',
                            price: 0,
                        },
                        {
                            title: 'Kist Fresa',
                            price: 0,
                        },
                        {
                            title: 'Maltin Polar',
                            price: 0,
                        },
                        {
                            title: 'Root Beer',
                            price: 0,
                        },
                        {
                            title: 'Malta',
                            price: 1.5,
                        },
                    ],
                },
                {
                    title: 'Combo Hotdog Panameño',
                    desc: '',
                    type: 'main',
                    pic: 'hot dog panameño.jpeg',
                    price: 7,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Coca Cola',
                            price: 0,
                        },
                        {
                            title: 'GingerAle',
                            price: 0,
                        },
                        {
                            title: 'Dr. Pepper',
                            price: 0,
                        },
                        {
                            title: 'Kist Fresa',
                            price: 0,
                        },
                        {
                            title: 'Maltin Polar',
                            price: 0,
                        },
                        {
                            title: 'Root Beer',
                            price: 0,
                        },
                        {
                            title: 'Malta',
                            price: 1.5,
                        },
                    ],
                },
                {
                    title: 'Combo Chillidog',
                    desc: '',
                    type: 'main',
                    pic: 'Combo Chillidog.jpeg',
                    price: 7.5,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Coca Cola',
                            price: 0,
                        },
                        {
                            title: 'GingerAle',
                            price: 0,
                        },
                        {
                            title: 'Dr. Pepper',
                            price: 0,
                        },
                        {
                            title: 'Kist Fresa',
                            price: 0,
                        },
                        {
                            title: 'Maltin Polar',
                            price: 0,
                        },
                        {
                            title: 'Root Beer',
                            price: 0,
                        },
                        {
                            title: 'Malta',
                            price: 1.5,
                        },
                    ],
                },
                {
                    title: 'Combo ChoriChili',
                    desc: '',
                    type: 'main',
                    pic: 'Combo Chillidog.jpeg',
                    price: 8,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Coca Cola',
                            price: 0,
                        },
                        {
                            title: 'GingerAle',
                            price: 0,
                        },
                        {
                            title: 'Dr. Pepper',
                            price: 0,
                        },
                        {
                            title: 'Kist Fresa',
                            price: 0,
                        },
                        {
                            title: 'Maltin Polar',
                            price: 0,
                        },
                        {
                            title: 'Root Beer',
                            price: 0,
                        },
                        {
                            title: 'Malta',
                            price: 1.5,
                        },
                    ],
                },
                {
                    title: 'Combo Choridog Hawaiano',
                    desc: '',
                    type: 'main',
                    pic: 'Combo hotdog choridog.jpeg',
                    price: 7.5,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Coca Cola',
                            price: 0,
                        },
                        {
                            title: 'GingerAle',
                            price: 0,
                        },
                        {
                            title: 'Dr. Pepper',
                            price: 0,
                        },
                        {
                            title: 'Kist Fresa',
                            price: 0,
                        },
                        {
                            title: 'Maltin Polar',
                            price: 0,
                        },
                        {
                            title: 'Root Beer',
                            price: 0,
                        },
                        {
                            title: 'Malta',
                            price: 1.5,
                        },
                    ],
                },
                {
                    title: 'Combo Choridog Panameño',
                    desc: '',
                    type: 'main',
                    pic: 'hot dog panameño.jpeg',
                    price: 7.5,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Coca Cola',
                            price: 0,
                        },
                        {
                            title: 'GingerAle',
                            price: 0,
                        },
                        {
                            title: 'Dr. Pepper',
                            price: 0,
                        },
                        {
                            title: 'Kist Fresa',
                            price: 0,
                        },
                        {
                            title: 'Maltin Polar',
                            price: 0,
                        },
                        {
                            title: 'Root Beer',
                            price: 0,
                        },
                        {
                            title: 'Malta',
                            price: 1.5,
                        },
                    ],
                },
                {
                    title: 'Combo Arepa',
                    desc: '',
                    type: 'main',
                    pic: '',
                    price: 8.5,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Coca Cola',
                            price: 0,
                        },
                        {
                            title: 'GingerAle',
                            price: 0,
                        },
                        {
                            title: 'Dr. Pepper',
                            price: 0,
                        },
                        {
                            title: 'Kist Fresa',
                            price: 0,
                        },
                        {
                            title: 'Maltin Polar',
                            price: 0,
                        },
                        {
                            title: 'Root Beer',
                            price: 0,
                        },
                        {
                            title: 'Malta',
                            price: 1.5,
                        },
                    ],
                },
                {
                    title: 'Combo Burrito',
                    desc: '',
                    type: 'main',
                    pic: 'combo burrito.jpeg',
                    price: 8.5,
                    styles: [
                        {
                            title: 'Carne',
                            price: 0,
                        },
                        {
                            title: 'Pollo',
                            price: 0,
                        },
                    ],
                    sides: [],
                    options: [
                        {
                            title: 'Coca Cola',
                            price: 0,
                        },
                        {
                            title: 'GingerAle',
                            price: 0,
                        },
                        {
                            title: 'Dr. Pepper',
                            price: 0,
                        },
                        {
                            title: 'Kist Fresa',
                            price: 0,
                        },
                        {
                            title: 'Maltin Polar',
                            price: 0,
                        },
                        {
                            title: 'Root Beer',
                            price: 0,
                        },
                        {
                            title: 'Malta',
                            price: 1.5,
                        },
                    ],
                },
                {
                    title: 'Combo Hamburguesa',
                    desc: '',
                    type: 'main',
                    pic: 'Combo Hamburguesa.jpeg',
                    price: 8.5,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Coca Cola',
                            price: 0,
                        },
                        {
                            title: 'GingerAle',
                            price: 0,
                        },
                        {
                            title: 'Dr. Pepper',
                            price: 0,
                        },
                        {
                            title: 'Kist Fresa',
                            price: 0,
                        },
                        {
                            title: 'Maltin Polar',
                            price: 0,
                        },
                        {
                            title: 'Root Beer',
                            price: 0,
                        },
                        {
                            title: 'Malta',
                            price: 1.5,
                        },
                    ],
                },
                {
                    title: 'Combo Hamburguesa Doble Carne',
                    desc: '',
                    type: 'main',
                    pic: '',
                    price: 12,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Coca Cola',
                            price: 0,
                        },
                        {
                            title: 'GingerAle',
                            price: 0,
                        },
                        {
                            title: 'Dr. Pepper',
                            price: 0,
                        },
                        {
                            title: 'Kist Fresa',
                            price: 0,
                        },
                        {
                            title: 'Maltin Polar',
                            price: 0,
                        },
                        {
                            title: 'Root Beer',
                            price: 0,
                        },
                        {
                            title: 'Malta',
                            price: 1.5,
                        },
                    ],
                },
                {
                    title: 'Combo Bulldog',
                    desc: '',
                    type: 'main',
                    pic: 'combo buldog.jpeg',
                    price: 11,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Coca Cola',
                            price: 0,
                        },
                        {
                            title: 'GingerAle',
                            price: 0,
                        },
                        {
                            title: 'Dr. Pepper',
                            price: 0,
                        },
                        {
                            title: 'Kist Fresa',
                            price: 0,
                        },
                        {
                            title: 'Maltin Polar',
                            price: 0,
                        },
                        {
                            title: 'Root Beer',
                            price: 0,
                        },
                        {
                            title: 'Malta',
                            price: 1.5,
                        },
                    ],
                },
                {
                    title: 'Arepas',
                    desc:
                        'Elige entre arepa de pollo, arepa de carne desmechada o arepa mixta.',
                    type: 'main',
                    pic: 'arepa_mixta.jpeg',
                    styles: [],
                    sides: [],
                    price: 4.5,
                    options: [
                        {
                            title: 'Pollo',
                            price: 0,
                        },
                        {
                            title: 'Chorizo',
                            price: 0,
                        },
                        {
                            title: 'Mixta',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Nachos',
                    desc:
                        'Nachos con pico de gallo, queso fundido y carne molida.',
                    type: 'main',
                    pic: 'nachos new.jpeg',
                    price: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Carne',
                            price: 4,
                        },
                        {
                            title: 'Pollo',
                            price: 4,
                        },
                        {
                            title: 'Personal Mixto',
                            price: 4.5,
                        },
                        {
                            title: 'Grande',
                            price: 6,
                        },
                        {
                            title: 'Grande Mixto',
                            price: 7,
                        },
                    ],
                },
                {
                    title: 'Papas con tender',
                    desc: '',
                    type: 'main',
                    pic: 'papas con tenders.jpeg',
                    price: 4,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Salchicha picada',
                    desc: '',
                    type: 'main',
                    pic: 'Salchicha picada.jpeg',
                    price: 1,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Chorizo picado',
                    desc: '',
                    type: 'main',
                    pic: 'Chorizo picado.jpeg',
                    price: 1.5,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Papas con chilli y Queso',
                    desc: '',
                    type: 'main',
                    pic: 'papas con chile y queso.jpeg',
                    price: 4,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Orden de papas',
                    desc: '',
                    type: 'main',
                    pic: 'Orden de papas.jpeg',
                    price: 1.5,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Alitas de pollo',
                    desc: '6 o 10 unidades.',
                    type: 'main',
                    pic: 'alitas.jpeg',
                    price: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: '6 unidades con papas',
                            price: 7,
                        },
                        {
                            title: '10 unidades',
                            price: 8.5,
                        },
                    ],
                },
                {
                    title: 'Soda',
                    desc:
                        'Coca Cola, GingerAle, Dr. Pepper, Kist Fresa, Maltin Polar, Root Beer',
                    type: 'main',
                    pic: 'soda.jpg',
                    price: 1,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Coca Cola',
                            price: 0,
                        },
                        {
                            title: 'GingerAle',
                            price: 0,
                        },
                        {
                            title: 'Dr. Pepper',
                            price: 0,
                        },
                        {
                            title: 'Kist Fresa',
                            price: 0,
                        },
                        {
                            title: 'Maltin Polar',
                            price: 0,
                        },
                        {
                            title: 'Root Beer',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Gatorade',
                    desc: '',
                    type: 'main',
                    pic: '',
                    price: 1.5,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Jugos de lata',
                    desc: 'Melocoton, Pera, Manzana.',
                    type: 'main',
                    pic: 'jugos.jpg',
                    price: 1,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Melocoton',
                            price: 0,
                        },
                        {
                            title: 'Pera',
                            price: 0,
                        },
                        {
                            title: 'Manzana',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Agua',
                    desc: 'Botella de agua de 600ml o 1lt',
                    type: 'main',
                    pic: 'agua.jpg',
                    price: 0,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Botella 600ml',
                            price: 1,
                        },
                        {
                            title: 'Botella 1lt',
                            price: 1.5,
                        },
                    ],
                },
                {
                    title: 'Maltas',
                    desc: '',
                    type: 'main',
                    pic: '',
                    price: 1.5,
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                },
                {
                    title: 'Batido',
                    desc:
                        'Batidos de fresa, maracuya, papaya, Melocoton, Guanabana, Cornflakes.',
                    type: 'main',
                    pic: 'batido.jpeg',
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Fresa',
                            price: 2.5,
                        },
                        {
                            title: 'Maracuya',
                            price: 2.5,
                        },
                        {
                            title: 'Papaya',
                            price: 2.5,
                        },
                        {
                            title: 'Melocoton',
                            price: 2.5,
                        },
                        {
                            title: 'Guanabana',
                            price: 2.5,
                        },
                        {
                            title: 'Melon',
                            price: 2.5,
                        },
                        {
                            title: 'Piña',
                            price: 2.5,
                        },
                        {
                            title: 'Guineo',
                            price: 2.5,
                        },
                        {
                            title: 'Cornflakes',
                            price: 2.5,
                        },
                    ],
                },
                {
                    title: 'Limonada con hierbabuena',
                    desc: '',
                    type: 'main',
                    pic: 'limonada.jpg',
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Regular',
                            price: 2.5,
                        },
                        {
                            title: 'Con fresa',
                            price: 2.5,
                        },
                    ],
                },
                {
                    title: 'Corvina entera',
                    subtitle: 'Solo viernes.',
                    desc: '',
                    type: 'extra',
                    pic: 'corvina entera.jpeg',
                    styles: [],
                    sides: [],
                    price: 10,
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                    days: [5],
                },
                {
                    title: 'Filete de pescado',
                    subtitle: 'Solo viernes.',
                    desc: 'Acompañado de patacones o papas.',
                    type: 'extra',
                    pic: 'filete_de_pescado.jpeg',
                    styles: [],
                    sides: [],
                    price: 8,
                    options: [
                        {
                            title: 'Patacones',
                            price: 0,
                        },
                        {
                            title: 'Papas',
                            price: 0,
                        },
                    ],
                    days: [5],
                },
                {
                    title: 'Saus',
                    subtitle: 'Solo viernes',
                    desc: '2 unidades.',
                    type: 'extra',
                    price: 4,
                    styles: [],
                    sides: [],
                    pic: 'saus.jpeg',
                    options: [
                        {
                            title: 'Regular',
                            price: 0,
                        },
                    ],
                    days: [5],
                },
                {
                    title: 'Ceviche',
                    subtitle: 'Solo viernes',
                    desc: '',
                    type: 'extra',
                    pic: 'ceviche.jpeg',
                    styles: [],
                    sides: [],
                    options: [
                        {
                            title: 'Tradicional 16oz.',
                            price: 5,
                        },
                        {
                            title: 'Gourmet 16oz.',
                            price: 6,
                        },
                    ],
                    days: [5],
                },
            ],
        }
    },
    methods: {
        isWeekendItem(item) {
            let today = new Date().getDay()
            if (item.type == 'main') {
                return false
            } else if (item.days.includes(today)) {
                return false
            } else {
                return true
            }
        },
        selectItem(index) {
            this.selectedItemIndex = index
            this.selectedItem = Object.assign({}, this.menu[index])
            if (this.selectedItem.styles.length > 0) {
                this.stylesDialog = true
                return
            }
            this.optionsDialog = true
        },
        checkIfDuplicate() {
            let isDuplicate = false
            if (this.cart.length <= 0) {
                isDuplicate = false
            }

            this.cart.forEach(c => {
                if (
                    c.type === this.selectedItem.type &&
                    c.title === this.selectedItem.title &&
                    c.options.title === this.selectedItem.options.title &&
                    c.styles.title === this.selectedItem.styles.title
                ) {
                    isDuplicate = true
                }
            })

            return isDuplicate
        },
        addItemToCart(section, item) {
            if (section === 'style') {
                this.selectedItem.styles = item
                this.stylesDialog = false
                this.optionsDialog = true
            } else {
                this.selectedItem.options = item
                if (!this.checkIfDuplicate()) {
                    this.selectedItem.amount = 1
                    this.cart.push(this.selectedItem)
                    this.optionsDialog = false
                    this.successDialog = true
                    this.calculateTotal()
                } else {
                    this.cart.forEach(c => {
                        if (
                            c.type === this.selectedItem.type &&
                            c.title === this.selectedItem.title &&
                            c.options.title ===
                                this.selectedItem.options.title &&
                            c.styles.title === this.selectedItem.styles.title
                        ) {
                            c.amount++
                        }
                    })
                    this.optionsDialog = false
                    this.successDialog = true
                    this.calculateTotal()
                }
            }
        },
        removeItemFromCart(i) {
            this.cart.splice(i, 1)
        },
        calculateTotal() {
            let total = 0
            this.cart.forEach(c => {
                if (c.price) total += c.price * c.amount
                if (c.options.price) total += c.options.price * c.amount
                if (c.styles.price) total += c.styles.price * c.amount
            })
            this.total = total
        },
        generateMessage() {
            let message =
                'Buenas me gustaria realizar un pedido de:%0D%0A%0D%0A'
            for (let item of this.cart) {
                message += `- (${item.amount}) ${item.title} ${
                    item.styles.title ? '- ' + item.styles.title + ' ' : ''
                }- ${item.options.title}%0D%0A`
            }
            message += `%0D%0ANo. de pedido: ${this.orderNo}%0D%0ANombre: ${this.name}`
            if (this.specialComments.length > 0)
                message += `%0D%0AComentarios especiales: ${this.specialComments}`
            if (this.selectedPickupMethod == 'Delivery') {
                message += `%0D%0AUbicacion: ${this.getLocationForMessage()}%0D%0ADireccion: ${
                    this.address
                }`
            }
            message += `%0D%0AMetodo de entrega: ${
                this.selectedPickupMethod
            }%0D%0AMetodo de pago: ${
                this.selectedPaymentMethod
            }%0D%0ATotal: $ ${this.total.toFixed(2)}`
            message = message.replace(/\+/g, '%2B')
            message = message.replace(/&/g, '%26')
            message = message.replace(/#/g, '%23')
            return message
        },
        async sendToGoogleDriveSheet() {
            let message = ''
            for (let item of this.cart) {
                if (item.type == 'main')
                    message += `(${item.amount}) ${item.title} con ${item.options.title}\n`
                if (item.type == 'extras')
                    message += `(${item.amount}) ${item.title} - ${item.options.title}\n`
                if (item.type == 'drinks')
                    message += `(${item.amount}) Bebida - ${item.options.title}\n`
            }
            let data = {
                id: this.orderNo,
                pedido: message,
                nombre: this.name,
                status: 'orden creada',
                total: this.total,
                metodo_de_pago: this.selectedPaymentMethod,
                metodo_de_entrega: this.selectedPickupMethod,
            }
            if (data.metodo_de_entrega === 'Delivery') {
                data.direcion_1 = this.getLocationForMessage()
                data.direcion_2 = this.address
            }
            var url =
                'https://script.google.com/macros/s/AKfycbybmCSxZchLRwk4V4B3ev_D0mIyXPiDtXTEA0lrBmgcGAetIJo/exec'
            var xhr = new XMLHttpRequest()
            xhr.open('POST', url)
            // xhr.withCredentials = true;
            xhr.setRequestHeader(
                'Content-Type',
                'application/x-www-form-urlencoded'
            )
            // url encode form data for sending as post data
            var encoded = Object.keys(data)
                .map(function(k) {
                    return (
                        encodeURIComponent(k) +
                        '=' +
                        encodeURIComponent(data[k])
                    )
                })
                .join('&')
            await xhr.send(encoded)
        },
        getLocationForMessage() {
            if (this.location.length === 0) {
                if (
                    parseFloat(this.center.lat) === parseFloat(9.068463) &&
                    parseFloat(this.center.lng) === parseFloat(-79.452694)
                ) {
                    return `>> Pedir Ubicacion !!`
                } else {
                    return `https://waze.com/ul?ll=${this.center.lat},${this.center.lng}&z=10`
                }
                // let lat = parseFloat(this.center.lat)
                // let lng = parseFloat(this.center.lng)
                // if (lat < 0) lat = `+${lat}`
                // if (lng < 0) lng = `+${lng}`
            } else {
                let lat = parseFloat(this.location.lat)
                let lng = parseFloat(this.location.lng)
                if (lat === NaN || lng === NaN) return `>> Pedir Ubicacion !!`
                // if (lat < 0) lat = `+${lat}`
                // if (lng < 0) lng = `+${lng}`
                return `https://waze.com/ul?ll=${lat},${lng}&z=10`
            }
        },

        setMarkerPosition(event) {
            this.location = event
        },
        setNewMarkerPosition(event) {
            this.markers = [{position: event}]
            this.location = event
        },
        geolocate() {
            navigator.geolocation.getCurrentPosition(
                position => {
                    this.center = {
                        lat: parseFloat(position.coords.latitude),
                        lng: parseFloat(position.coords.longitude),
                    }
                    this.markers.push({position: this.center})
                },
                error => {
                    this.center = {
                        lat: parseFloat(9.068463),
                        lng: parseFloat(-79.452694),
                    }
                    this.markers.push({position: this.center})
                }
            )
        },
        async sendChat() {
            if (this.name == '') {
                alert('Debes ingresar tu nombre para enviar el pedido.')
                return
            }
            if (this.selectedPickupMethod == '') {
                alert('Debes seleccionar un metodo de entrega.')
                return
            }
            if (this.address == '' && this.selectedPickupMethod == 'Delivery') {
                alert(
                    'Debes ingresar tu direccion completa para la entrega de tu pedido.'
                )
                return
            }
            if (this.selectedPaymentMethod == null) {
                alert('Debes seleccionar un metodo de pago.')
                return
            } else {
                if (this.selectedPickupMethod == 'Delivery')
                    this.deliveryCostDialog = true
                else {
                    this.confirmChat()
                }
            }
        },
        confirmChat() {
            this.orderNo = Math.floor(100000 + Math.random() * 900000)
            this.$analytics.logEvent('wp-panamahotdog', {
                content_action: 'Orden Completada',
            })
            // await this.sendToGoogleDriveSheet()
            window.location.href = `https://wa.me/507${
                this.whatsappNumber
            }?text=${this.generateMessage()}`
        },
    },
    watch: {
        cart() {
            this.calculateTotal()
            if (this.cart.length > 0) {
                this.seamless = true
                this.$store.commit('SET_DISPLAYFOOTER', true)
            } else {
                this.seamless = false
                this.$store.commit('SET_DISPLAYFOOTER', false)
            }
        },
        // selectedPickupMethod() {
        //     if (this.selectedPickupMethod == 'Delivery')
        //         this.locationDialog = true
        // },
    },
    components: {
        GoogleMaps,
    },
    mounted() {
        if (this.$hj) {
            this.$hj('vpv', 'funnel-step-one')
        }
        this.$store.commit('SET_DISPLAYFOOTER', false)
        let path = this.$route.params.path
        this.$analytics.logEvent('wp-panamahotdog', {
            path,
        })
        this.geolocate()
    },
}
